import tippy from 'tippy.js';

export default function (el) {
    const button = el.querySelector(".tippy-button");
    const template = el.querySelector(".tippy-template");
    const tippyConfigJson = el.dataset.tippyConfigJson;
    let tippyConfig = {}

    if(!button || !template) return;

    if(tippyConfigJson) {
        try {
            tippyConfig = JSON.parse(tippyConfigJson);
        } catch(e) {}
    }

    tippy(button, {
        content: template.innerHTML,
        allowHTML: true,
        interactive: true,
        ...tippyConfig,
    });
}